import { prettifyNumbers } from "./prettifyNumbers";

interface GetCourierServiceToggleTextProps {
  hasAddress: boolean;
  isTaxiMasterTurned: boolean;
  shippingMethodCost: number | null;
  isCalculateTaxiShippingPending: boolean;
}

export const getCourierServiceToggleText = ({
  hasAddress,
  shippingMethodCost,
  isTaxiMasterTurned,
  isCalculateTaxiShippingPending,
}: GetCourierServiceToggleTextProps): string => {
  // * Если нет адреса, то нет и стоимости доставки - (нет ручек - нет конфетки) (простите)
  if (!hasAddress) {
    return "Для вычисления стоимости доставки, необходимо создать адрес";
  }

  // * Если стоимость доставки считается
  if (isCalculateTaxiShippingPending) {
    return "Вычисление стоимости доставки...";
  }

  // * Если такси мастер включен и нет загрузки и нет стоимости доставки
  if (isTaxiMasterTurned && !isCalculateTaxiShippingPending) {
    if (shippingMethodCost === null) {
      return "По тарифу курьерской службы";
    }

    return `Стоимость доставки: ${prettifyNumbers(shippingMethodCost)} ₽`;
  }

  return "По тарифу курьерской службы";
};
